module.exports = __webpack_public_path__ + "img/g2w-logo-lmi.c0f43bf6.svg";